import { makeStyles } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";

export default makeStyles(theme => ({
    root: {
        margin: 'auto',
    },
    cardHeader: {
        padding: theme.spacing(1, 2),
    },
    list: {
        width: 200,
        height: 230,
        backgroundColor: theme.palette.background.paper,
        overflowY: 'auto',
    },
    button: {
        margin: theme.spacing(0.5, 0),
    },
    listHeader: {
        textAlign: 'center',
    },
    axaLabel:{
        height: '24px',
        color: '#333333',
        fontFamily: "Source Sans Pro",
        fontSize: '16px',
        fontWeight: '600',
        letterSpacing: '0',
        lineHeight: '14px',
    },
    axaField:{
        boxSizing: 'border-box',
        height: '48px',
        border: '1px solid #CCCCCC',
        borderRadius: '8px',
        backgroundColor: '#FFFFFF',
    },
    filterFieldBox:{
        marginBottom:'5px'
    },
    filterBox:{
        margin:'0px 0px 10px 0px'
    }

}));

export const getMuiTheme = (selectedTheme) => {
    return createMuiTheme({
        ...selectedTheme,
        overrides: {
            MuiListItem:{
                root:{
                    paddingTop:0,
                    paddingBottom:0
                }
            },
            MuiListItemIcon:{
                root:{
                    minWidth:0
                }
            },
            MuiTypography:{
                body1:{
                    fontSize:'0.875rem'
                }
            },
            MuiFormLabel:{
                root:{
                    fontSize:'0.875rem'
                }
            },
            PrivateSwitchBase:{
                root:{
                    padding:5
                }
            },
            MuiPaper:{
                root:{
                    border:"1px solid #ebeaea"
                },
                elevation1:{boxShadow:'none'}
            },
            MuiButton: {
                root:{
                  borderRadius:'8px !important'
                },
            },
        },
    })
}
